interface RibbonControlConstants {
    borderRadius: number;
    chevronIconSize: number;
    iconSize: number;
    rootHeight: number;
    rootMarginTop: number;
    splitButtonMenuButtonWidth: number;
}

export const getButtonRootConstants = (isHeroStyle?: boolean): RibbonControlConstants => {
    return {
        borderRadius: 4,
        chevronIconSize: isHeroStyle ? 16 : 12,
        iconSize: 20,
        rootHeight: 32,
        rootMarginTop: 4,
        splitButtonMenuButtonWidth: isHeroStyle ? 28 : 16,
    };
};

/* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
 * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
 *	> Function getButtonRootConstants called at module scope is not allowed. This may cause unwanted side effects. */
export const singleLineRibbonStyleConstants: RibbonControlConstants = getButtonRootConstants(false);
